/*
 * Audit actions
 */

/** Get all for relevant user audits action constant */
export const GET_ALL_AUDITS = 'DFIM_GET_ALL_AUDITS';
export const GET_ALL_AUDITS_SUCCESS = 'DFIM_GET_ALL_AUDITS_SUCCESS';
export const GET_ALL_AUDITS_ERROR = 'DFIM_GET_ALL_AUDITS_ERROR';

/**
 * This starts when the user is logged in
 * @return {object}       An action object with a type of GET_ALL_AUDITS.
 *
 * */
export const getAllAudits = (data) => ({ type: GET_ALL_AUDITS, payload: data });
/**
 * Dispatched when the audits are loaded.
 * @param {object}       the companies loaded from the backend.
 * @return {object}       An action object with a type of GET_ALL_AUDITS_SUCCESS passing the audits.
 *
 * */
export const getAllAuditsSuccess = (data) => ({
  type: GET_ALL_AUDITS_SUCCESS,
  payload: data,
});
/**
 * Dispatched when the audits failed to load
 * @param  {object} error The error
 * @return {object}       An action object with a type of GET_ALL_AUDITS_ERROR passing the error
 *
 * */
export const getAllAuditsError = (error) => ({
  type: GET_ALL_AUDITS_ERROR,
  error: error,
});

/** Get all audits action constant */
export const GET_USER_AUDITS = 'DFIM_GET_USER_AUDITS';
export const GET_USER_AUDITS_SUCCESS = 'DFIM_GET_USER_AUDITS_SUCCESS';
export const GET_USER_AUDITS_ERROR = 'DFIM_GET_USER_AUDITS_ERROR';

/**
 * This starts when the user is logged in
 * @return {object}       An action object with a type of GET_USER_AUDITS.
 *
 * */
export const getUserAudits = (data) => ({
  type: GET_USER_AUDITS,
  payload: data,
});
/**
 * Dispatched when the audits are loaded.
 * @param {object}       the companies loaded from the backend.
 * @return {object}       An action object with a type of GET_USER_AUDITS_SUCCESS passing the audits.
 *
 * */
export const getUserAuditsSuccess = (data) => ({
  type: GET_USER_AUDITS_SUCCESS,
  payload: data,
});
/**
 * Dispatched when the audits failed to load
 * @param  {object} error The error
 * @return {object}       An action object with a type of GET_USER_AUDITS_ERROR passing the error
 *
 * */
export const getUserAuditsError = (error) => ({
  type: GET_USER_AUDITS_ERROR,
  error: error,
});

/** Get all audits action constant */
export const GET_AUDIT_TYPES = 'DFIM_GET_AUDIT_TYPES';
export const GET_AUDIT_TYPES_SUCCESS = 'DFIM_GET_AUDIT_TYPES_SUCCESS';
export const GET_AUDIT_TYPES_ERROR = 'DFIM_GET_AUDIT_TYPES_ERROR';

/**
 * This starts when the user is logged in
 * @return {object}       An action object with a type of GET_USER_AUDITS.
 *
 * */
export const getAuditTypes = () => ({ type: GET_AUDIT_TYPES });
/**
 * Dispatched when the audits are loaded.
 * @param {object}       the companies loaded from the backend.
 * @return {object}       An action object with a type of GET_USER_AUDITS_SUCCESS passing the audits.
 *
 * */
export const getAuditTypesSuccess = (data) => ({
  type: GET_AUDIT_TYPES_SUCCESS,
  payload: data,
});
/**
 * Dispatched when the audits failed to load
 * @param  {object} error The error
 * @return {object}       An action object with a type of GET_USER_AUDITS_ERROR passing the error
 *
 * */
export const getAuditTypesError = (error) => ({
  type: GET_AUDIT_TYPES_ERROR,
  error: error,
});
